<template>
  <div id="pageHeader" class=" mb-0 md:mb-4">
    <div class="flex justify-between items-center border-b border-[#313131] md:border-none pb-4 md:pb-0">
      <div class="min-w-44 flex-none flex gap-2 md:mr-6">

        <span @click="openMenuMobile"
          class="  md:hidden flex items-center    m-0 p-0  text-hrmThemeTextColor rounded-lg">
          <Icon icon="octicon:sidebar-collapse-24" width="25px" height="25px" />
        </span>
        <div class="hidden md:block ">

          <span
            class="flex-none flex items-center justify-center w-12 h-12 bg-hrmThemeBgColor text-hrmThemeTextColor rounded-lg">
            <Icon icon="tdesign:component-breadcrumb" width="25px" height="25px" />
          </span>
        </div>
        <div class="flex-none flex flex-col   items-start justify-center md:justify-start">
          <p class="flex items-center gap-2 text-xl md:text-lg text-mainTitleLight dark:text-mainTitleDark font-bold">
            {{ title }}
          </p>
          <p v-if="subtitle" class="text-gray-600 hidden md:block dark:text-gray-300 text-sm">
            {{ subtitle }}
          </p>
          <div v-if="breadCrumb && breadCrumb.length > 0" class="hrmPageBreadCurmb">
            <span v-for="(item, index) in breadCrumb" :key="index" :class="item?.active ? 'hrmActiveBreadCrumb' : ''">
              {{ item.name }}<span v-if="index !== breadCrumb.length - 1"> / </span>
            </span>
          </div>
        </div>
      </div>
      <div class="">
        <div class=" hidden md:block">

          <slot name="counters"></slot>

        </div>
        <div class="md:hidden">
          <TableMenuW v-if="$slots.counters" icon="typcn:chart-pie">
            <template v-slot:menuItems>
              <div class="tablemenu-slot-wrapper">

                <slot name="counters"></slot>
              </div>


            </template>
          </TableMenuW>
        </div>

      </div>
    </div>
    <div>
      <slot name="extraPage"></slot>
    </div>
  </div>
</template>
<script>
import Link from "@/Components/Common/Link.vue";
import ButtonCard from "@/Components/Common/ButtonCard.vue";
import { Icon } from "@iconify/vue";
import LoadingIcon from "@/Common/LoadingIcon.vue"; 
import TableMenuW from "./TableMenuW.vue";


export default {
  name: "PageHeader",
  
  components: {
    Icon,
    LoadingIcon,
    ButtonCard,
    Link,
    TableMenuW
  },
  props: {
    title: {
      type: String,
      default: "",
    },
    subtitle: {
      type: String,
      default: "",
    },
    addPermission: {
      type: String,
      default: "",
    },
    modalData: {
      type: Object,
      default: {},
    },
    newQuoteId: {
      type: Number,
      default: null
    },
    selectedDataCount: {
      type: Object,
      default: {}
    },
    dataCount: {
      type: Number,
      default: null
    },
    breadCrumb: {
      type: Array,
    }
  },
  data() {
    return {
      isActions: false,
      quoteId: this.newQuoteId ? this.newQuoteId : ""
    };
  },

  watch: {
    selectedDataCount: {
      handler(newVal, oldVal) {
      },
      deep: true,
    },
    dataCount: {
      handler(newVal, oldVal) {
      },
      deep: true,
    }
  },
  methods: {
    openAdd() {
      this.$emit("openAdd");
    },
    openMenuMobile() {
      document.body.classList.add('toggleMenu');
    },
    openMultiDelete() {
      this.$emit("openMultiDelete");
    },
    openTrash() { },
    back() {
      window.history.back();
    },
  },
};
</script>
<style scoped>
/*breadcrumb design*/
.themeBreadcrumb .themeBreadcrumbItem {
  padding: 2px 16px;
  position: relative;
}

.themeBreadcrumb .themeBreadcrumbItem:first-child {
  padding-left: 0;
}

.themeBreadcrumb .themeBreadcrumbItem:first-child:before {
  content: "";
}

.border {
  border: 0.5px solid;
  border-image-source: linear-gradient(90deg,
      rgba(75, 75, 75, 0) 0%,
      #4B4B4B 50%,
      rgba(75, 75, 75, 0) 100%);
}

.themeBreadcrumb .themeBreadcrumbItem:before {
  content: "-";
  position: absolute;
  left: -2px;
}

@media (max-width: 768px) {
  .tablemenu-slot-wrapper> :deep(div:first-child) {
    display: block !important;

  }


}
</style>